import { useMemo } from 'react';

// Hook to detect if user is in New York state
export const useNYStateDetection = (userLocation) => {
  return useMemo(() => {
    try {
      if (!userLocation || userLocation === "unknown") {
        return false;
      }
      
      const locationData = JSON.parse(userLocation);
      const countryCode = locationData?.countryCode;
      
      if (countryCode !== "US") {
        return false;
      }
      
      const zipcode = locationData?.zipcode;
      if (!zipcode) return false;
      
      const zip3 = zipcode.substring(0, 3);
      
      // New York (NY): 100-149
      return zip3 >= '100' && zip3 <= '149';

    } catch (error) {
      return false;
    }
  }, [userLocation]);
};

export default useNYStateDetection;